// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3fHBL","footer":"ModalError_footer__1EFaa"};